import { cssVar, Flex, VStack, Box, Text, Popover, PopoverContent, PopoverTrigger } from '@cad-arc';
import { UnitQueueView } from '@mark43/cad-api';
import { filterOutPrimaryUnit, isUnitPrimaryAndNotSolo } from '../unit-queues/utils';

function UnitChip({
    isPrimaryAndNotSolo,
    callSign,
}: {
    isPrimaryAndNotSolo?: boolean;
    callSign?: string;
}) {
    return (
        <Box
            textAlign="center"
            borderRadius="var(--arc-radii-base)"
            px={3}
            bgColor={
                isPrimaryAndNotSolo
                    ? cssVar('arc.colors.warning.default')
                    : cssVar('arc.colors.brand.accent')
            }
            cursor="default"
        >
            <Text
                fontSize={isPrimaryAndNotSolo ? 'md' : 'lg'}
                fontWeight="bold"
                style={{
                    color: isPrimaryAndNotSolo
                        ? cssVar('arc.colors.warning.content')
                        : cssVar('arc.colors.brand.accentContent'),
                }}
            >
                {callSign}
            </Text>
        </Box>
    );
}

export function FrAssistingUnitChip({ unit }: { unit: UnitQueueView }) {
    const isPrimaryAndNotSolo = isUnitPrimaryAndNotSolo(unit);
    const assignedUnitsToShow = filterOutPrimaryUnit(unit) ?? [];

    return (
        <Flex alignItems="center" gap={1}>
            <UnitChip
                isPrimaryAndNotSolo={isPrimaryAndNotSolo}
                callSign={isPrimaryAndNotSolo ? 'PRIMARY' : unit.unitIsAssisting}
            />
            {assignedUnitsToShow.length > 0 && (
                <Popover>
                    <PopoverTrigger>
                        <Text
                            color="brand"
                            style={{ cursor: 'pointer', textDecoration: 'underline' }}
                            data-testid="assigned-units-count-btn"
                        >
                            +{assignedUnitsToShow.length}
                        </Text>
                    </PopoverTrigger>
                    <PopoverContent align="end" style={{ maxHeight: '50vh', overflowY: 'scroll' }}>
                        <VStack alignItems="center" gap={1} data-testid="assigned-units-call-signs">
                            {assignedUnitsToShow.map((unit) => (
                                <UnitChip key={unit.id} callSign={unit.callSign} />
                            ))}
                        </VStack>
                    </PopoverContent>
                </Popover>
            )}
        </Flex>
    );
}
